import React, {useEffect, useRef} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProducts, selectProducts } from '../redux/productsSlice';
import ProductCard from './ProductCard';
import './Products.css';

const Accessoires = () => {
  const products = useSelector(selectProducts);
  const dispatch = useDispatch();


  useEffect(() => {
    dispatch(fetchProducts());
  }, [dispatch]);
  const accessoiresProducts = products.filter(product => product.category === 'Accessoires');

  const productsRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    const containers = productsRef.current.querySelectorAll('.product-card');
    containers.forEach(container => observer.observe(container));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="products" ref={productsRef}>
      {accessoiresProducts.map(product => (
        <ProductCard key={product._id} product={product} />
      ))}
    </div>
  );
};

export default Accessoires;
